import { useEffect } from 'react';

import { initializeLogRocket } from '../monitoring/logrocket';

export const useLogrocketTracking = () => {
  useEffect(() => {
    initializeLogRocket();
  }, []);
};
